import { Money } from 'shared/types/common';
import { SHOW_SELL_SUBMITTED_MODAL, HIDE_SELL_SUBMITTED_MODAL, Action } from 'actions';

export interface State {
  amount: Money;
}

const initState: State = {
  amount: { value: 0, currency: 'USD' },
};

export default function reducer(state: State = initState, action: Action): State {
  switch (action.type) {
    case SHOW_SELL_SUBMITTED_MODAL:
      return {
        ...state,
        amount: action.payload.amount,
      };
    case HIDE_SELL_SUBMITTED_MODAL:
      return initState;
    default:
      return state;
  }
}
